import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { isBrowser } from "react-device-detect";
import { useSelector, useDispatch } from "react-redux";
import Axios from "axios";
import { Row, Col, Image } from "react-bootstrap";

//STYLES
import * as UserRouteSystemStyles from "./styles/userRouteSystem";

//ACTIONS
import * as UserActions from "../../store/actions/user";
import * as GS_generalSettings from "../../store/actions/globalSettings/GS_generalSettings";

import EnvironmentPodsMap from "../pods/environmentPodsMap";

//IMAGES
// import StGilesPic from "../../public/images/stGiles.jpeg";

//USER SIDE
import BrowserNavBar from "../pods/special/navBar/browserNavBar";
// import MobileNavBar from "../pods/special/navBar/mobileNavBar";

//COMPONENTS
import Hub from "../pods/gamesHub/frontEnd/files//hub";
import MembershipExtra from "../pods/membershipExtra/mainFiles/frontEnd/podRouter";

//FROM ADMIN CORE SIDE
import AdminBanner from "../../administration/pods/adminBanner/adminBanner";
import PageViewer from "../../administration/pods/pageViewer/pageViewer";
import PodViewer from "../../administration/pods/wholeSite/podViewer";
import FrontEndMainContact from "../../administration/pods/contacts/files/frontEndMainContact";
import SiteOffline from "../../administration/pods/siteOffline/files/siteOffline";

function UserRouteSystem() {
    const user = useSelector((state) => state.user);

    const [isLoaded, setIsLoaded] = useState(false);
    const [isOffline, setIsOffline] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        onOpen();
    }, []);

    function onOpen() {
        Axios.post("/pods/userRouter/getOpeningData")
            .then((res) => {
                const data = res.data;
                console.log(data);
                dispatch(GS_generalSettings.UpdateMainContactPageVisible(data.settings.mainContactPage.value == "true"));
                dispatch(GS_generalSettings.UpdateSiteOffline(data.settings.siteOffline.value == "true"));
                dispatch(GS_generalSettings.UpdateSiteOfflineMessage(data.settings.siteOffline.subValue));
                setIsOffline(data.settings.siteOffline.value == "true");

                if (user.auth && user.type !== "registered") {
                    dispatch(UserActions.UpdateAdminSignedIn(true));
                }

                //MEMBERSHIP EXTRA POD
                if (user.requestedPassword) {
                    navigate("/membership/changePassword");
                }
                if (!user.auth) {
                    navigate("/membership/login");
                }

                setIsLoaded(true);
            })
            .catch((err) => console.log(err));
    }

    function offlineUserCheck(role) {
        if (role == "modifier" || role == "registered" || role == "") {
            return false;
        } else {
            return true;
        }
    }

    return (
        <div>
            {isLoaded && (
                <div>
                    {isOffline && !offlineUserCheck(user.type) ? (
                        <div>
                            <SiteOffline />
                        </div>
                    ) : (
                        <div>
                            <Row>
                                <Col>
                                    <Row>
                                        <Col style={UserRouteSystemStyles.mainBody}>
                                            <Routes>
                                                <Route path="/*" element={<Hub />} />
                                                <Route path="/membership/*" element={<MembershipExtra />} />
                                            </Routes>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default UserRouteSystem;
